import React from 'react';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

import { AppAdsBasePlacement } from './app-ads-base-placement';
import { getAppAdsCasualGamesStyles } from '../../styles/ad-placement-components/app-ads-ad-placement-styles';
import { withUAPLThemedStyles } from '../../with-themed-styles';
import { PlacementHeadline } from '../../shared-components';


export const AppAdsCasualGamesDimensionsPlacement = withUAPLThemedStyles(
  (props) => {
    const {
      classes,
      placementData, // UAPVMSingleImagePlacement
      shortHeadline,
      i18n, // may need to set window._TL_ in other platforms
    } = props;

    const {
      placementMeta, placementCropping, imageMeta, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
    } = placementData || {};
    const { previewHeight, aspectRatio } = placementMeta || {};
    if (!placementData || !imageMeta) {
      return null;
    }

    const cropping = expandedPlacementCropping || placementCropping;

    return (
      <AppAdsBasePlacement classes={classes}>
        <div className={classes.casualGamesBase}>
          <CroppedImageView
            resizeImageHeight={previewHeight}
            aspectRatio={aspectRatio}
            src={effectiveImageUrl || imageMeta.url}
            originalWidth={effectiveImageWidth || imageMeta.originalWidth}
            originalHeight={effectiveImageHeight || imageMeta.originalHeight}
            SourceX={cropping && cropping.SourceX}
            SourceY={cropping && cropping.SourceY}
            SourceWidth={cropping && cropping.SourceWidth}
            SourceHeight={cropping && cropping.SourceHeight}
          />
          <div className={classes.msnPlacementTextContainer}>
            <PlacementHeadline
              headlineText={shortHeadline}
              placementHeadlineClassName={classes.casualGamesHeadline}
              i18n={i18n}
            />
          </div>
        </div>
      </AppAdsBasePlacement>
    );
  },
  getAppAdsCasualGamesStyles,
  { componentName: 'AppAdsCasualGamesDimensionsPlacement' }
);
